import styled from 'styled-components'

interface RectangleButtonProps {
  position: number
  width: number
}

export const BirthButton = styled.button<RectangleButtonProps>`
  position: absolute;
  top: 50%;
  left: ${props => props.position}%;
  width: ${props => props.width}%;
  min-width: 45px;
  height: 45px;
  transform: translateY(-50%);

  border: none;
  border-radius: 6px;
  background: transparent;

  > span {
    height: 100%;
  }

  &:focus {
    filter: drop-shadow(0px 0px 1px #000);
    outline: none;
  }
  &:hover {
    z-index: 999;
  }
`

export const Content = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  svg {
    position: relative;
    pointer-events: none;
    fill: ${({ theme }) => theme.zds.colors.neutral1000};
    width: 25px;
    height: 25px;
  }

  .background {
    position: absolute;
    inset: 0;
    background: ${props => props.theme.colors.color5be1f6};
    box-shadow: 0px 4px 4px ${props => props.theme.colors.colorBlack29};
    border-radius: 6px;
    border: 1px solid ${({ theme }) => theme.zds.colors.neutral1000};
    opacity: 1;
  }

  .background:hover {
    filter: brightness(0.8);
  }
`
